import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardBody, Collapse, Table, Button } from 'reactstrap';

class TransactionLogPanel extends React.Component {
    state = {
        isOpen: false
    };

    _toggle = () => {
        this.setState(prev => ({ isOpen: !prev.isOpen }));
    };

    render() {
        const { transactions } = this.props;
        const { isOpen } = this.state;

        if (!transactions || transactions.length === 0) {
            return null;
        }

        return (
            <Card className="mt-4">
                <CardHeader
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: 'pointer' }}
                    onClick={this._toggle}
                >
                    <span>
                        <strong>Transaction Log</strong>
                        <span className="text-muted ml-2">({transactions.length} transactions)</span>
                    </span>
                    <Button color="link" size="sm">
                        {isOpen ? 'Collapse' : 'Expand'}
                    </Button>
                </CardHeader>
                <Collapse isOpen={isOpen}>
                    <CardBody className="p-0">
                        <Table size="sm" striped responsive className="mb-0">
                            <thead>
                                <tr>
                                    <th>Timestamp</th>
                                    <th>Product ID</th>
                                    <th>Product Name</th>
                                    <th>SKU</th>
                                    <th>PO Qty</th>
                                    <th>Delta</th>
                                    <th>Saturn Response</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.map((tx, idx) => (
                                    <tr key={idx}>
                                        <td>{new Date(tx.timestamp).toLocaleString()}</td>
                                        <td>K{tx.productId}</td>
                                        <td>{tx.productName}</td>
                                        <td>{tx.sku}</td>
                                        <td>{tx.poQty}</td>
                                        <td className={tx.delta < 0 ? 'text-danger' : 'text-success'}>
                                            {tx.delta}
                                        </td>
                                        <td>
                                            <pre className="mb-0" style={{ fontSize: '11px', maxWidth: '400px', overflow: 'auto' }}>
                                                {JSON.stringify(tx.saturnResponse, null, 2)}
                                            </pre>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Collapse>
            </Card>
        );
    }
}

TransactionLogPanel.propTypes = {
    transactions: PropTypes.array.isRequired
};

export { TransactionLogPanel };
